import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: #fff;\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: 5px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  width: fit-content;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import * as IconModule from "../icons";
import { socials } from "../config";
import { Flex } from "../../Box";
var Icons = IconModule;
var IconLabel = styled.span.withConfig({
    componentId: "sc-d9015795-0"
})(_templateObject());
var StyledLink = styled.a.withConfig({
    componentId: "sc-d9015795-1"
})(_templateObject1());
var SocialLinks = function() {
    return /*#__PURE__*/ _jsx(Flex, {
        style: {
            flexWrap: "wrap",
            paddingTop: "12px"
        },
        children: socials.map(function(social, index) {
            var Icon = Icons[social.icon];
            var iconProps = {
                width: "22px",
                height: "22px",
                color: "#fff",
                style: {
                    cursor: "pointer"
                }
            };
            var mr = index < socials.length - 1 ? "0px" : 0;
            return /*#__PURE__*/ _jsx(StyledLink, {
                href: social.href,
                style: {
                    marginRight: mr,
                    width: "33.33%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: index === 0 || index === 3 ? "flex-start" : index === 2 || index === 5 ? "flex-end" : "center",
                    marginBottom: "10px"
                },
                target: "_blank",
                children: /*#__PURE__*/ _jsx("div", {
                    style: {
                        lineHeight: 0,
                        marginLeft: index === 0 ? "-2px" : "0"
                    },
                    children: social.imgUrl ? /*#__PURE__*/ _jsx("img", {
                        src: social.imgUrl,
                        width: "18",
                        height: "18",
                        alt: "logo",
                        style: {
                            marginRight: "0px"
                        }
                    }) : /*#__PURE__*/ _jsx(Icon, _object_spread({}, iconProps))
                })
            }, social.id);
        })
    });
};
export default /*#__PURE__*/ React.memo(SocialLinks, function() {
    return true;
});
